export var QuoteEventType;
(function (QuoteEventType) {
    /** When PAIDNICE first inserted the quote, NOT the issue date */
    QuoteEventType["IMPORTED"] = "imported";
    /** When any status changes to `ACCEPTED` anytime as long as the prior status was not ACCEPTED */
    QuoteEventType["ACCEPTED"] = "accepted";
    /** When any status changes to `DECLINED` anytime as long as the prior status was not DECLINED */
    QuoteEventType["DECLINED"] = "declined";
    /** When any status changes to `SENT` anytime as long as the prior status was not SENT | DECLINED | ACCEPTED */
    QuoteEventType["SENT"] = "sent";
})(QuoteEventType || (QuoteEventType = {}));
export const quoteEventLanguageMap = {
    timeline: {
        [QuoteEventType.IMPORTED]: {
            description: `The quote was imported into Paidnice`,
        },
        [QuoteEventType.ACCEPTED]: {
            description: `The quote was accepted`,
        },
        [QuoteEventType.DECLINED]: {
            description: `The quote was declined`,
        },
        [QuoteEventType.SENT]: {
            description: `The quote was sent`,
        },
    },
};
//# sourceMappingURL=quoteEvent.js.map